// src\services\MediaDataService.js

import http from '../http-image-common';

class MediaDataService {
  getAll() {
    return http.get("/media");
  }

  getAllType(id) {
    return http.get(`/media/type/${id}`);
  }

  get(id) {
    return http.get(`/media/edit/${id}`);
  }

  create(data) {
    return http.post("/media/add", data);
  }

  update(id, data) {
    return http.put(`/media/update/${id}`, data);
  }

  delete(id) {
    return http.put(`/media/delete/${id}`);
  }
}

export default new MediaDataService();
